import { Injectable } from '@angular/core';
import { PdfExportCertificatesGeBaseService } from './pdf-export-certificates-ge-base.service';

@Injectable()
export class PdfExportCertificatesGeLevel1Service extends PdfExportCertificatesGeBaseService {

  protected needsManagementRepresentitiveSignature = false;
  constructor(
  ) {
    super()
  }

  protected getAuthorisingEngineerSignatureUrl(): string {
    return this.signatureUrlGarySmith;
  }

  protected getAuthorisingEngineerSignatureName(): string {
    return 'Gary Smith';
  }

  // unrequired because needsManagementRepresentitiveSignature is false
  protected getManagementRepresentitiveSignatureUrl(): string {
    return undefined;
  }

  // unrequired because needsManagementRepresentitiveSignature is false
  protected getManagementRepresentitiveSignatureName(): string {
    return undefined;
  }

  protected fillInApprovedCodes(): void {
    this.doc.setFont('helvetica', 'bold');
    this.doc.text('C', 56, 539); // E1C
    this.doc.text('C', 56, 555); // E2C
    this.doc.text('C', 56, 627); // G1C
    this.doc.setFont('helvetica', 'normal');
  }
}
